import { Grid, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import React, { Fragment } from "react";
import NumberFormat from "react-number-format";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    color: "#FFF",
    background: theme.palette.secondary.main,
    height: "100%",
  },
  listItem: {
    color: "#FFF",
  },
  subheader: {
    wordWrap: "break-word",
  },
}));

export default function AddressBillingDetailListing(props) {
  const classes = useStyles();
  const { countries } = props;
  const { firstName, lastName, countryCode, line1, line2, state, city, postalCode, emailAddress, phoneNumber } = props.values;
  return (
    <Fragment>
      <List className={classes.root} dense>
        <Grid container>
          {(firstName != "") &&
            <Grid item xs={12}>
              <ListItem>
                <ListItemText
                  primary="First Name"
                  secondary={
                    <Typography variant="h6" className={classes.subheader}>
                      {firstName}
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>}
          {(lastName != "") && <Grid item xs={12}>
            <Divider />
            <ListItem>
              <ListItemText
                primary="Last Name"
                secondary={
                  <Typography variant="h6" className={classes.subheader}>
                    {lastName}
                  </Typography>
                }
              />
            </ListItem>
          </Grid>}
          {(countryCode != "") && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="Country"
                  secondary={
                    <Typography variant="h6" className={classes.subheader}>
                      {(countries.find(x => x.isoCode === countryCode).name || "")}
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>
          )}
          {(line2 != "") && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="Address Line 1"
                  secondary={
                    <Typography variant="h6" className={classes.subheader}>
                      {line1}
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>
          )}
          {(line2 != "") && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="Address Line 2"
                  secondary={
                    <Typography variant="h6" className={classes.subheader}>
                      {line2}
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>
          )}
          {(state != "") && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="State"
                  secondary={
                    <Typography variant="h6" className={classes.subheader}>
                      {state}
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>
          )}
          {(city != "") && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="City"
                  secondary={<Typography variant="h6">{city}</Typography>}
                />
              </ListItem>
            </Grid>
          )}
          {postalCode && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="Postal Code"
                  secondary={<Typography variant="h6">{postalCode}</Typography>}
                />
              </ListItem>
            </Grid>
          )}
          {emailAddress && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="Email"
                  secondary={<Typography variant="h6">{emailAddress}</Typography>}
                />
              </ListItem>
            </Grid>
          )}
          {phoneNumber && (
            <Grid item xs={12}>
              <Divider />
              <ListItem>
                <ListItemText
                  primary="Phone Number"
                  secondary={
                    <Typography variant="h6" className={classes.subheader}>
                      <NumberFormat
                        value={phoneNumber}
                        format="#(###)###-####"
                        placeholder="#(###)###-####"
                        displayType="text"
                      />
                    </Typography>
                  }
                />
              </ListItem>
            </Grid>
          )}
        </Grid>
      </List>
    </Fragment>
  );
}
